var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hospitalCategories, hospitalEntityName } from '../../../../backend/config/shared';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { capitalize } from '@mui/material';
import React from 'react';
function getEntityTitle(row) {
    return row.columns.name;
}
const statesByFips = {
    '01': 'Alabama',
    '02': 'Alaska',
    '04': 'Arizona',
    '05': 'Arkansas',
    '06': 'California',
    '08': 'Colorado',
    '09': 'Connecticut',
    '10': 'Delaware',
    '11': 'District of Columbia',
    '12': 'Florida',
    '13': 'Georgia',
    '15': 'Hawaii',
    '16': 'Idaho',
    '17': 'Illinois',
    '18': 'Indiana',
    '19': 'Iowa',
    '20': 'Kansas',
    '21': 'Kentucky',
    '22': 'Louisiana',
    '23': 'Maine',
    '24': 'Maryland',
    '25': 'Massachusetts',
    '26': 'Michigan',
    '27': 'Minnesota',
    '28': 'Mississippi',
    '29': 'Missouri',
    '30': 'Montana',
    '31': 'Nebraska',
    '32': 'Nevada',
    '33': 'New Hampshire',
    '34': 'New Jersey',
    '35': 'New Mexico',
    '36': 'New York',
    '37': 'North Carolina',
    '38': 'North Dakota',
    '39': 'Ohio',
    '40': 'Oklahoma',
    '41': 'Oregon',
    '42': 'Pennsylvania',
    '44': 'Rhode Island',
    '45': 'South Carolina',
    '46': 'South Dakota',
    '47': 'Tennessee',
    '48': 'Texas',
    '49': 'Utah',
    '50': 'Vermont',
    '51': 'Virginia',
    '53': 'Washington',
    '54': 'West Virginia',
    '55': 'Wisconsin',
    '56': 'Wyoming',
};
function getStateNameByFips(fips) {
    if (fips) {
        const name = statesByFips[fips];
        return name !== null && name !== void 0 ? name : '';
    }
    else {
        return '';
    }
}
const EntityDetailsComponent = (props) => {
    var _a;
    const { t } = useCredentialingTranslation();
    return (React.createElement(SlideoutFields, { fields: [
            { label: 'Status', value: capitalize(props.response.data.status) },
            { label: 'Address Line 1', value: props.response.data.addressLine1 },
            { label: 'Address Line 2', value: props.response.data.addressLine2 },
            { label: 'Category', value: t(`hospitalCategories.${(_a = props.response.data.category) !== null && _a !== void 0 ? _a : 'unknown'}`) },
            { label: 'City', value: props.response.data.city },
            { label: 'Contact Number', value: props.response.data.contactNumber },
            { label: 'Emergency Contact Number', value: props.response.data.emergencyContactNumber },
            { label: 'State', value: getStateNameByFips(props.response.data.state) },
            { label: 'ZIP', value: props.response.data.zip },
            { label: 'Automatic Verification', value: props.response.data.automaticVerification ? 'Yes' : 'No' },
            { label: 'Affiliation Verifiable', value: props.response.data.affiliationVerifiable ? 'Yes' : 'No' },
        ] }));
};
const getFormConfig = (t) => ({
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: 'Name',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: 'Status',
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: 'Active',
                },
                {
                    value: 'deprecated',
                    label: 'Deprecated',
                },
                {
                    value: 'retired',
                    label: 'Retired',
                },
            ],
        },
        {
            type: 'form.text',
            key: 'addressLine1',
            label: 'Address Line 1',
            defaultValue: '',
        },
        {
            type: 'form.text',
            key: 'addressLine2',
            label: 'Address Line 2',
            defaultValue: '',
        },
        {
            type: 'form.select',
            key: 'category',
            label: 'Category',
            values: hospitalCategories.map((value) => ({ value: value, label: t(`hospitalCategories.${value}`) })),
        },
        {
            type: 'form.text',
            key: 'city',
            label: 'City',
            defaultValue: '',
        },
        {
            type: 'form.text',
            key: 'contactNumber',
            label: 'Contact Number',
            defaultValue: '',
        },
        {
            type: 'form.text',
            key: 'emergencyContactNumber',
            label: 'Emergency Contact Number',
            defaultValue: '',
        },
        {
            type: 'form.select',
            key: 'state',
            label: 'State',
            values: Object.entries(statesByFips).map(([value, label]) => ({ value: value, label: label })),
        },
        {
            type: 'form.text',
            key: 'zip',
            label: 'ZIP',
            defaultValue: '',
        },
        {
            type: 'form.checkbox',
            key: 'automaticVerification',
            label: 'Automatic Verification',
        },
        {
            type: 'form.checkbox',
            key: 'affiliationVerifiable',
            label: 'Affiliation Verifiable',
        },
    ],
});
const csvFileHeader = [
    'ID',
    'Name',
    'Status',
    'Address Line1',
    'Address Line2',
    'Category',
    'City',
    'Contact Number',
    'Emergency Contact Number',
    'State',
    'ZIP',
    'Automatic Verification',
    'Affiliation Verifiable',
];
function mapCsvRowToData(row) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let i = -1;
    const id = ((_a = row.data[++i]) !== null && _a !== void 0 ? _a : '').trim();
    const name = ((_b = row.data[++i]) !== null && _b !== void 0 ? _b : '').trim();
    const status = ((_c = row.data[++i]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
    const addressLine1 = ((_d = row.data[++i]) !== null && _d !== void 0 ? _d : '').trim();
    const addressLine2 = ((_e = row.data[++i]) !== null && _e !== void 0 ? _e : '').trim();
    const category = ((_f = row.data[++i]) !== null && _f !== void 0 ? _f : '').trim();
    const city = ((_g = row.data[++i]) !== null && _g !== void 0 ? _g : '').trim();
    const contactNumber = ((_h = row.data[++i]) !== null && _h !== void 0 ? _h : '').trim();
    const emergencyContactNumber = ((_j = row.data[++i]) !== null && _j !== void 0 ? _j : '').trim();
    const state = ((_k = row.data[++i]) !== null && _k !== void 0 ? _k : '').trim();
    const zip = ((_l = row.data[++i]) !== null && _l !== void 0 ? _l : '').trim();
    const automaticVerification = ((_m = row.data[++i]) !== null && _m !== void 0 ? _m : '').trim().toLowerCase() === 'yes';
    const affiliationVerifiable = ((_o = row.data[++i]) !== null && _o !== void 0 ? _o : '').trim().toLowerCase() === 'yes';
    if (name.length === 0) {
        row.errors.push('Name is required');
    }
    if (status.length === 0) {
        row.errors.push('Status is required');
    }
    switch (status) {
        case 'active':
        case 'deprecated':
        case 'retired':
            break;
        default:
            row.errors.push('Invalid status, expected one of: active, deprecated, retired');
    }
    if (row.errors.length === 0) {
        row.object = {
            id: id,
            data: {
                name: name,
                status: status,
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                category: category,
                city: city,
                contactNumber: contactNumber,
                emergencyContactNumber: emergencyContactNumber,
                state: state,
                zip: zip,
                automaticVerification: automaticVerification,
                affiliationVerifiable: affiliationVerifiable,
            },
        };
    }
    return Promise.resolve(row);
}
function mapDataToCsvRow(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return [
            response.id,
            response.data.name,
            response.data.status,
            (_a = response.data.addressLine1) !== null && _a !== void 0 ? _a : '',
            (_b = response.data.addressLine2) !== null && _b !== void 0 ? _b : '',
            (_c = response.data.category) !== null && _c !== void 0 ? _c : '',
            (_d = response.data.city) !== null && _d !== void 0 ? _d : '',
            (_e = response.data.contactNumber) !== null && _e !== void 0 ? _e : '',
            (_f = response.data.emergencyContactNumber) !== null && _f !== void 0 ? _f : '',
            (_g = response.data.state) !== null && _g !== void 0 ? _g : '',
            (_h = response.data.zip) !== null && _h !== void 0 ? _h : '',
            response.data.automaticVerification ? 'Yes' : 'No',
            response.data.affiliationVerifiable ? 'Yes' : 'No',
        ];
    });
}
export const HospitalAdminPage = () => {
    const { t } = useCredentialingTranslation();
    return (React.createElement(ClassifierAdminPage, { entity: hospitalEntityName, title: 'Hospital', fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, formConfig: getFormConfig(t), csvFileHeader: csvFileHeader, mapCsvRowToData: mapCsvRowToData, mapDataToCsvRow: mapDataToCsvRow }));
};
